import * as React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, CardLink, Col, Container, Fade, Row, Input, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Dispatch } from 'redux';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faTimes, faBookOpen, faEdit, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { LoadingSpinnerModal, ConfirmModal, DABTextBox, DABDropDown } from '../../components/dab';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import ReactPaginate from 'react-paginate';
import { bibleAction } from '../../actions/bibleAction';
import { showAlert } from "../common/functions";

interface IBibleProps {
	dispatch: Dispatch<any>;
	bibleData: any;
	langcode: any;
}

const BibleList: React.SFC<IBibleProps> = ({
	dispatch, bibleData, langcode }) => {

	const history = useHistory();
	const initialValue = [{ text: "", value: 0, checked: false }];

	const initialInputValue = {
		languageCodes: [] as string[],
		uniqueCodes: [] as string[],
		pageNumber: 1,
		pageSize: 25,
		sortColumn: "Language",
		sortDirection: "asc",
		isCommonFilter: false,
		isLanguageFilter: false
	};

	const [formSubmit1, setformSubmit1] = useState(false);
	const [fadeIn, setFadeIn] = useState(false);
	const [selectedId, setSelectedId] = useState(-1);
	const [currentPageNo, setCurrentPageNo] = useState(0);
	const [pageList, setPageList] = useState([1]);
	const [languageList, setLanguageList] = useState(initialValue);
	const [uniqueCodeList, setUniqueCodeList] = useState(initialValue);
	const [filterInput, setFilterInput] = useState(initialInputValue);
	const [showModal, setShowModal] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [showClearFilter, setShowClearFilter] = useState(false);
	const [isRestore, setIsRestore] = useState(false);
	const [isMessageErr, setIsMessageErr] = useState(false);
	const [inputBibleTitle, setInputBibleTitle] = useState("");
	const [selectedBibleTitle, setSelectedBibleTitle] = useState("");
	const [selLangcode, setSelLangCode] = useState(langcode);

	const handleLoadShowModal = (value: boolean) => {
		setShowModal(value);
	};

	const handleFilterClose = () => {
		handleToggle();
	}

	const handleFilterClear = () => {
		localStorage.removeItem("langCode");
		setSelLangCode("");
		setFadeIn(false);
		bibleData.isFilterAndTotalCountDataLoaded = false;
		setCurrentPageNo(0);
		var input = initialInputValue;
		input.isCommonFilter = false;
		input.isLanguageFilter = false;
		setFilterInput(initialInputValue);
		var list: any[] = [];
		uniqueCodeList.forEach((data) => {
			var item = { text: data.text, value: data.value, checked: true };
			list.push(item);
		});
		setUniqueCodeList(list);

		var list1: any[] = [];
		languageList.forEach((data) => {
			var item = { text: data.text, value: data.value, checked: true };
			list1.push(item);
		});
		setLanguageList(list1);

		setShowClearFilter(false);
		dispatch(bibleAction.bibleGetByFilter(input));
		sessionStorage.removeItem("Filter")
	}

	const handleToggle = () => setFadeIn(!fadeIn);

	const handleFilter = () => {
		localStorage.removeItem("langCode");
		setSelLangCode("");
		var selectedLanguageCodes = languageList.filter(x => x.checked === true).map(function (v) {
			return v.value.toString();
		});
		var selectedUniqueCodes = uniqueCodeList.filter(x => x.checked === true).map(function (v) {
			return v.value.toString();
		});
		setFilterInput({
			...filterInput,
			languageCodes: selectedLanguageCodes,
			uniqueCodes: selectedUniqueCodes,
			pageNumber: 1,
			isCommonFilter:true
		});
		setCurrentPageNo(0);
		bibleData.isFilterAndTotalCountDataLoaded = false;
		setShowClearFilter(true);
		handleToggle();
	};

	const handleFilterRestore = () => {
		var filter = sessionStorage.getItem("Filter");
		if (filter != null && filter.trim() != "") {
			var filterObj  = JSON.parse(filter.toString());
			if (filterObj != null) {
				setFilterInput(filterObj);
				setCurrentPageNo(filterObj.pageNumber-1)
				setIsRestore(true);
				sessionStorage.removeItem("fromPage");
			}
		}
	}

	const handleSort = (sortColumn) => {
		var input = filterInput;
		var sDir = "asc"
		if (input.sortColumn === sortColumn) {
			if (input.sortDirection === "desc") {
				sDir = "asc";
			}
			else {
				sDir = "desc";
			}
		}
		setFilterInput({
			...filterInput,
			sortColumn: sortColumn,
			sortDirection: sDir
		})
	};

	const handleSetPageNumber = (pageNo) => {
		setFilterInput({
			...filterInput,
			pageNumber: pageNo,
		});
	};

	const handleSortIcon = (sortColumn) => {
		var input = filterInput;
		if (input.sortColumn === sortColumn) {
			if (input.sortDirection === "desc") {
				return <FontAwesomeIcon className='column-sort-icon' icon={faChevronUp} />
			}
			else {
				return <FontAwesomeIcon className='column-sort-icon' icon={faChevronDown} />
			}
		}
	}

	const handleLanguageChange = (value, checked) => {
		languageList.forEach((data) => {
			if (data.value === value) {
				data.checked = checked;
			}
		});
		setLanguageList(languageList);
		setformSubmit1(!formSubmit1);
	};

	const handleSelectAllLanguage = (e) => {
		languageList.forEach((data) => data.checked = e.target.checked);
		setLanguageList(languageList);
		setformSubmit1(!formSubmit1);
	}

	const handleUniqueCodeChange = (value, checked) => {
		uniqueCodeList.forEach((data) => {
			if (data.value === value) {
				data.checked = checked;
			}
		});
		setUniqueCodeList(uniqueCodeList);
		setformSubmit1(!formSubmit1);
	};

	const handleSelectAllUniqueCode = (e) => {
		uniqueCodeList.forEach((data) => data.checked = e.target.checked);
		setUniqueCodeList(uniqueCodeList);
		setformSubmit1(!formSubmit1);
	}

	const handleDeleteModal = () =>
	{
		if (selectedBibleTitle.trim().toLowerCase() == inputBibleTitle.trim().toLowerCase()) {
				dispatch(bibleAction.bibleDelete(selectedId));
				setShowModal(true);
				setShowDeleteModal(false);
				setIsMessageErr(false);
		}
		else {
			setIsMessageErr(true);
		};
	};

	const handleCloseClick = () => {
		setShowDeleteModal(false);
	}

	const handleSelectForDelete = (id: number, title: string) => {
		setSelectedId(id);
		setSelectedBibleTitle(title);
		setInputBibleTitle("");
		setIsMessageErr(false);
		setShowDeleteModal(true);
	};

	const handleReadingList = (bibleId: number) => {
		localStorage.setItem("bibleId",JSON.stringify(bibleId));
	};
	
	const handleInputChange = (event) => {
		const value = event.target.value;
		setIsMessageErr(false);
		setInputBibleTitle(value);
	};

	const handleGetSortColumn = (display, value) => {
		return <div className='column-div' onClick={(e) => { handleSort(value); }}>
			{display}
			{value === filterInput.sortColumn && (handleSortIcon(value))}
		</div>
	}

	const handlePageClick = (data) => {
		handleSetPageNumber(data.selected + 1);
		setCurrentPageNo(data.selected);
	};


	React.useEffect(() => {
		if (selLangcode)
		{
			filterInput.languageCodes = [selLangcode];
			filterInput.isLanguageFilter = true;
			setShowClearFilter(true);
		}

		var fromPage = sessionStorage.getItem("fromPage");

		if (fromPage && fromPage.trim().toLowerCase() === 'bible') {
			handleFilterRestore();
		}

		if (initialInputValue != filterInput) {
			sessionStorage.setItem("Filter", JSON.stringify(filterInput));
		} else {
			sessionStorage.removeItem("Filter");
		}

		dispatch(bibleAction.bibleGetByFilter(filterInput));
		setShowModal(true);

	}, [filterInput]);

	if (showModal && !bibleData.isLoading) {
		if (bibleData.isListSuccess) {
			bibleData.isListSuccess = false;
			setShowModal(false);
			var total: number = bibleData.totalCount;
			var pList: number[] = [];
			if (total > initialInputValue.pageSize) {
				for (var i = 1; i <= (total / initialInputValue.pageSize); i++) {
					pList.push(i);
				}
				if ((total % initialInputValue.pageSize) > 0) {
					pList.push((parseInt((total / initialInputValue.pageSize).toString()) + 1));
				}
			}
			else {
				pList.push(1);
			}
			setPageList(pList);
			if (languageList && languageList.length <= 1) {
				var list: any[] = [];
				bibleData.languages.forEach((data) => {
					var item = { text: data.name, value: data.languageCode, checked: true };
					if (selLangcode && selLangcode !== '') {
						item.checked = selLangcode === data.languageCode ? true : false;
					}
					list.push(item);
				});
				setLanguageList(list);
			}
			else {
				var list0: any[] = [];
				languageList.forEach((data) => {
					list0.push({ text: data.text, value: data.value, checked: data.checked });
				});
				setLanguageList(list0);
			}

			if (uniqueCodeList && uniqueCodeList.length <= 1) {
				var list1: any[] = [];
				bibleData.uniqueCodes.forEach((data) => {
					list1.push({ text: data, value: data, checked: true });
				});
				setUniqueCodeList(list1);
			}
			else {
				var list2: any[] = [];
				uniqueCodeList.forEach((data) => {
					list2.push({ text: data.text, value: data.value, checked: data.checked });
				});
				setUniqueCodeList(list2);
			}
		}
	}

	if (selectedId >= -1 && bibleData.isSuccess && bibleData.isDeleteCompleted && !bibleData.isError) {
		showAlert(bibleData.status, false);
		bibleData.isSuccess = false;
		bibleData.isDeleteCompleted = false;
		dispatch(bibleAction.bibleGetByFilter(filterInput));
		setFilterInput(initialInputValue)
		setSelectedId(-1);
		setSelectedBibleTitle("");
		setInputBibleTitle("");
		setIsMessageErr(false);
		setShowDeleteModal(false);
	}

	if (!bibleData.isSuccess && bibleData.isError) {		
		if (bibleData.status === 'Unauthorized') {
			history.push("/401");
		} else {
			showAlert(bibleData.status, true);
		}
		setSelectedId(-1);
		bibleData.isError = false;
		if (showModal) {
			setShowModal(false);
		}
		setSelectedBibleTitle("");
		setInputBibleTitle("");
		setIsMessageErr(false);
		setShowDeleteModal(false);
	}

	if (isRestore && bibleData.languages) {
		if (filterInput.languageCodes.length > 0) {
				var list: any[] = [];
				bibleData.languages.forEach((data) => {
					if (filterInput.languageCodes.indexOf(data.languageCode) > -1)
						var item = { text: data.name, value: data.languageCode, checked: true };					
					else 
						var item = { text: data.name, value: data.languageCode, checked: false };
										
					list.push(item);
				});
				setLanguageList(list);						
		}
		if (filterInput.uniqueCodes.length > 0) {
			var list: any[] = [];
			bibleData.uniqueCodes.forEach((data) => {
				if (filterInput.uniqueCodes.indexOf(data) > -1)
					var item = { text: data, value: data, checked: true };
				else
					var item = { text: data, value: data, checked: false };

				list.push(item);
			});
			setUniqueCodeList(list);			
		}
		setIsRestore(false);
		setShowClearFilter(true);
	}

	return (
		<div >			
			<div className="bible-list">				
				<div className='card-box'>
					<Row className='filter-link-container'>
						<Col lg="8" className='column'>
							<CardLink onClick={handleToggle} className='card-box-link'>Filter List</CardLink>
							{showClearFilter ?
								<CardLink onClick={handleFilterClear} className='card-box-link-filter'>Clear Filter</CardLink>
								: <CardLink className='card-box-link-filter-disabled'>Clear Filter</CardLink>}
						</Col>						
							<Button data-testid="createNewBible" id="submit" className="btn-submit-frm" onClick={() => window.location.href = "/bible?page=add"}>Create New</Button>
					</Row>
					{fadeIn && (
						<Fade in={fadeIn} tag="div" className='card-fade'>
							<Container className='filter-container'>
								<div className='box-container'>
									<div>
										<Row >
											<Col lg="11">
												<label>Languages</label>
												<div>
													<div className="all-select filterRow">
														<Input type="checkbox" className='box-container-input'
															checked={languageList.every((item) => item.checked === true)}
															onChange={handleSelectAllLanguage} />
														All Language
													</div>
													<Row xs="4">
														{
															languageList && languageList.map((data: any) =>
																<Col lg="2" className='filterRow' key={data.value}>
																	<Input type="checkbox" checked={data.checked} className='box-container-input' name={data.text}
																		onChange={(e) => handleLanguageChange(data.value, e.target.checked)}>
																	</Input>
																	<span>{data.text}</span>
																</Col>
															)}
													</Row>
												</div>
											</Col>
											<Col lg="1">
												<div className='close-div'>
													<FontAwesomeIcon cursor='pointer' size='3x' data-bs-toggle="tooltip"
														data-bs-placement="bottom" title="Close" icon={faTimes}
														onClick={handleFilterClose} />
												</div>
											</Col>
										</Row>
										<div className="divider-line"></div>
										<Row >
											<Col lg="11">
												<label>Code</label>
												<div>
													<div className="all-select filterRow">
														<Input type="checkbox" className='box-container-input'
															checked={uniqueCodeList.every((item) => item.checked === true)}
															onChange={handleSelectAllUniqueCode} />
														All Unique Code
													</div>
													<Row xs="4">
														{
															uniqueCodeList && uniqueCodeList.map((data: any) =>
																<Col lg="2" className='filterRow' key={data.value}>
																	<Input type="checkbox" className='box-container-input'
																		name={data.text} checked={data.checked}
																		onChange={(e) => handleUniqueCodeChange(data.value, e.target.checked)}>
																	</Input>
																	<span>{data.text}</span>
																</Col>
															)}
													</Row>
												</div>
											</Col>
											<Col lg="1">
												<Button type="button" id="submit" className="inner-filter-link"
													onClick={handleFilter}>Filter</Button>
											</Col>
										</Row>
									</div>
								</div>
							</Container>
						</Fade>)}
				</div>
				<div className="bible-table">
					<table data-testid="bibleTable" className="table table-hover">
						<thead>
							<tr>
								<th scope="col" data-testid="bible-detailColumn">Details</th>
								<th scope="col" data-testid="bible-languageColumn">{handleGetSortColumn("Language", "Language")}</th>
								<th scope="col" data-testid="bible-codeColumn">{handleGetSortColumn("Code", "CODE")}</th>
								<th scope="col" data-testid="bible-titleColumn">{handleGetSortColumn("Title", "TITLE")}</th>
								<th scope="col" data-testid="bible-viewReadingColumn">View Reading</th>
								<th scope="col" data-testid="bible-deleteColumn">Delete</th>
							</tr>
						</thead>
						<tbody data-testid="bibleTableBody" >
							{
								bibleData && bibleData.items.map((data: any) =>
									<tr key={data.bibleId} >
										<th scope="row" className="icon-column">
											<a href={`/bible?id=${data.bibleId}`} className="detail-link" data-testid="bibleDetailButton"
											 onClick={()=>sessionStorage.setItem("fromPage","bible") }>
												<FontAwesomeIcon cursor='pointer' size='2x' icon={faEdit} title="Details"  />
											</a>
										</th>
										<td id="language">{data.language}</td>
										<td id="uniqueCode">{data.uniqueCode}</td>
										<td id="title">{data.title}</td>
										<td className="icon-column">
											<a onMouseDown={() => handleReadingList(data.bibleId) }  href={`/reading`} className="detail-link" data-testid="reading">
												<FontAwesomeIcon cursor='pointer' size='2x' icon={faBookOpen} data-bs-toggle="tooltip" data-bs-placement="bottom" title="Open readings" />
											</a>
										</td>
										<td data-testid="bibleDeleteButton" className="icon-column">
											<FontAwesomeIcon cursor='pointer' size='2x' icon={faTrashAlt} data-bs-toggle="tooltip"
												data-bs-placement="bottom" title="Delete" onClick={() => handleSelectForDelete(data.bibleId,data.title)} />
										</td>
									</tr>
								)}
							{bibleData && bibleData.items.length <= 0 &&
								<tr className="no-data">
									<th scope="row" colSpan={6}>
										<h4> No data found </h4>
									</th>
								</tr>}
						</tbody>
					</table>
				</div>
				<div className="pagination">
					<ReactPaginate
						previousLabel={'<<'}
						nextLabel={'>>'}
						breakLabel={'...'}
						pageCount={pageList.length}
						marginPagesDisplayed={2}
						pageRangeDisplayed={10}
						onPageChange={handlePageClick}
						forcePage={currentPageNo}
						containerClassName={'pagination'}
						pageClassName={"page-item"}
						previousClassName={"page-item"}
						breakClassName={"page-item"}
						breakLinkClassName={"page-link"}
						nextClassName={"page-item"}
						pageLinkClassName={"page-link"}
						previousLinkClassName={"page-link"}
						nextLinkClassName={"page-link"}
						activeClassName={'active'}
					/>
				</div>
				{
					showModal && (
						<LoadingSpinnerModal isShowModal={showModal} modalChange={handleLoadShowModal} />
					)
				}
				<Modal isOpen={showDeleteModal} backdrop="static" centered data-testid="deleteModal">
					<ModalHeader className="modal-header" >
						Delete Bible
					</ModalHeader>
					<ModalBody className="modal-body">
						<form name="deleteBibleForm">
							<div className={["col-sm-12 col-form-label"].join(" ")}>Are you sure, Do you want to remove this bible? If Yes, type the name of the bible you want to remove.
							</div>
							<div className={["col-sm-12 row mb-3"].join(" ")}>
								<label data-testid="bibleTitleText" className={["col-sm-5 col-form-label"].join(" ")}>Type Bible Title</label>
								<div className={["col-sm-6"].join(" ")} data-testid="bibleTitleContainer">
									<DABTextBox className={["form-control"].join(" ")} id="bibleTitle" value={inputBibleTitle} isRequired={true}
										onChange={(event) => { handleInputChange(event) }} isHover={false} />
								</div>
							</div>
							<div data-testid="messageErr" style={{ display: `${isMessageErr ? '' : 'none'}` }} className={["col-sm-12 row mb-3"].join(" ")}><label data-testid="bibleTitleErr" className="text-danger">Typed Bible Title Is Incorrect</label></div>
						</form>
					</ModalBody>
					<ModalFooter>
						<Button type="button" color="secondary" data-bs-dismiss="modal" onClick={handleCloseClick} data-testid="cancelDeleteButton">Cancel</Button>
						<Button type="button" color="primary" onClick={handleDeleteModal} data-testid="confirmDeleteButton">Confirm Delete</Button>
					</ModalFooter>
				</Modal>
			</div>			
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { bibleData } = state;
	return {
		bibleData
	};
};

export default connect(mapStateToProps)(BibleList);
